export { elementContainsAttribute } from '@fluentui/dom-utilities';
